import { createAction, props } from "@ngrx/store";

export const setFocus = createAction(
  "[Focus] Set Focus",
  props<{ focus: string }>(),
);
